import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function DatePicker(props) {
  const classes = useStyles();
  const {label, value, setValue} = props;

  const handleChange = (e) => {
    setValue(format(new Date(e.target.value), 'yyyy-MM-dd'))
  }

  return (
    <form className={classes.container} noValidate>
      <TextField
        id="date"
        label={label}
        type="date"
        // defaultValue={format(new Date(), 'yyyy-MM-dd')}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        value = {value}
        onChange={handleChange}
      />
    </form>
  );
}
